var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.465)",
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.035,
    width: 2,
    height: 55.035,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.097 47.264l5.293 4.953a1 1 0 001.372-.005l5.205-4.939a1 1 0 011.377 1.451L8.77 54.961a1 1 0 01-1.371.005L.73 48.724a1 1 0 111.367-1.46z",
    fillRule: "nonzero"
  }))));
}

export default SvgIconArrowDown;